import { AxiosError } from "axios";
import { toast } from "react-toastify";

import api from "../api";

async function getQueuePositionByDriverId(id?: number, options?: NextApp.ServiceOptions<NextApp.Queue>) {
  if (!id) {
    console.warn("Driver ID is required to check if the driver is in the queue.");
    return { data: null, isSuccess: false, isError: true };
  }

  options?.onInit?.();
  try {
    const { data } = await api.get<NextApp.Queue>(`queue/position/driver/${id}`);
    options?.onSuccess?.(data);

    return { data, isSuccess: true, isError: false };
  } catch (error) {
    if (error instanceof AxiosError) {
      const errorMessage = error.response?.data?.message || "Erro ao buscar posição na fila.";
      toast.error(errorMessage);
    }

    console.error("Error fetching queue position by driver ID:", error);
    options?.onError?.(error);

    return { data: null, isSuccess: false, isError: true };
  } finally {
    options?.onFinally?.();
  }
}

async function getHasDriverByDriverId(id?: number, options?: NextApp.ServiceOptions<NextApp.QueueHasDriver>) {
  if (!id) {
    console.warn("Driver ID is required to check if the driver is in the queue.");
    return { data: null, isSuccess: false, isError: true };
  }

  options?.onInit?.();
  try {
    const { data } = await api.get<NextApp.QueueHasDriver>(`queue/hasDriver/${id}`);
    options?.onSuccess?.(data);

    return { data, isSuccess: true, isError: false };
  } catch (error) {
    console.error("Error checking if driver is in queue:", error);
    toast.error("Erro ao verificar se o motorista está na fila. Tente novamente.");
    options?.onError?.(error);

    return { data: null, isSuccess: false, isError: true };
  } finally {
    options?.onFinally?.();
    console.log(`Finished checking if driver is in queue ID: ${id}`);
  }
}

async function getQueueByCompanyId(id?: number, options?: NextApp.ServiceOptions<NextApp.QueueCompanyById[]>) {
  if (!id) {
    console.warn("Driver Company ID is required to fetch the queue.");
    return { data: [], isSuccess: false, isError: true };
  }

  // toast.info("Buscando fila por ID da empresa de motorista...");

  options?.onInit?.();
  try {
    const { data } = await api.get<NextApp.QueueCompanyById[]>(`queue/company/${id}`);
    options?.onSuccess?.(data);

    return { data, isSuccess: true, isError: false };
  } catch (error) {
    console.error("Error fetching queue by driver company ID:", error);
    toast.error("Erro ao buscar fila. Tente novamente.");
    options?.onError?.(error);

    return { data: [], isSuccess: false, isError: true };
  } finally {
    options?.onFinally?.();
  }
}

async function getQueueDelayStatusByCompanyId(id: number, options?: NextApp.ServiceOptions<NextApp.DelayStatus>) {
  options?.onInit?.();

  try {
    const { data } = await api.get<NextApp.DelayStatus>(`queue/delayStatus/company/${id}`);
    options?.onSuccess?.(data);

    return { data, isSuccess: true, isError: false };
  } catch (error) {
    if (error instanceof AxiosError) {
      const errorMessage = error.response?.data?.message;
      options?.onError?.(error);
      console.error("Error fetching queue delay status by company ID:", error);
      if (errorMessage === "Nenhum Atraso Foi Registrado!") {
        // toast.info(errorMessage);
        return { data: null, isSuccess: true, isError: false };
      }

      return { data: null, isSuccess: false, isError: true, error: error.response?.data };
    }
    return { data: null, isSuccess: false, isError: true };
  } finally {
    options?.onFinally?.();
  }
}

export const queueQueries = {
  getQueueDelayStatusByCompanyId,
  getQueuePositionByDriverId,
  getHasDriverByDriverId,
  getQueueByCompanyId
};
